import { types } from 'mobx-state-tree';
import { fetchWeatherInformation } from './flows/weather';
import { loadable } from '../../mobx-utils';

export const optionalMaybeNull = (T) =>
  types.optional(types.maybeNull(T), null);

export const Precipitation = types.model('Precipitation', {
  totalAsRain: types.maybeNull(types.number),
  type: types.maybeNull(types.number),
  probability: types.maybeNull(types.number),
  total: types.maybeNull(types.number),
});

export const Temperature = types.model('Temperature', {
  avg: types.maybeNull(types.number),
  max: types.number,
  min: types.number,
  unit: types.string,
});

export const Wind = types.model('Wind', {
  avg: types.maybeNull(types.number),
  direction: types.string,
  max: types.number,
  min: types.number,
  unit: types.string,
});
export const Astronomy = types.model('Astronomy', {
  sunrise: types.string,
  sunset: types.string,
  moonphase: types.string,
  zodiac: types.string,
});

export const WeatherError = types.model('Error', {
  error_message: types.string,
});

export const Weather = types.model('Weather', {
  date: types.string,
  rainHours: types.maybeNull(types.number),
  state: types.number,
  sunHours: types.number,
  precipitation: Precipitation,
  temperature: Temperature,
  wind: Wind,
  astronomy: Astronomy,
  stateDescription: optionalMaybeNull(types.string),
  stateIcon: optionalMaybeNull(types.string),
  stateImage: optionalMaybeNull(types.string),
});

export const ForecastSummary = loadable(
  types.array(types.array(Weather || WeatherError)),
  fetchWeatherInformation,
);

export const WeatherStore = types.model({ forecastSummary: ForecastSummary });
